import { useFirebase } from 'FeatureModules/Auth/Contexts/FirebaseContext';

export enum EFeatureFlag {
  UNDER_MAINTENANCE = 'underMaintenance',
  CUSTOM_LABEL_ENABLED = 'customLabelEnabled',
  ENABLE_SUBMISSION_OF_STATEMENTS = 'enableSubmissionOfStatements',
}

const useFeatureFlags = () => {
  const { featureFlags } = useFirebase();

  const isFeatureEnabled = (feature: EFeatureFlag) => {
    return !!featureFlags[feature] && featureFlags[feature] === true;
  };

  return { isFeatureEnabled };
};

export default useFeatureFlags;
